
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { supabase } from "@/integrations/supabase/client";
import { getErrorMessage } from './authErrorHandler';

export const useLoginHandler = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  // Login function with Supabase
  const handleLogin = async (
    e: React.FormEvent,
    email: string,
    password: string
  ) => {
    e.preventDefault();
    
    if (!email || !password) {
      return;
    }
    
    setLoading(true);
    
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      
      if (error) throw error;
      
      // Redirect to home page or intended destination
      navigate('/', { replace: true });
      
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      
      toast({
        title: "Login failed",
        description: errorMessage,
        variant: "destructive",
      });
      
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleLogin
  };
};
